import BaseEditPage from "./BaseEditPage";
import * as g from "../common/gisFuncs";
import * as f from '../common/Funcs';
import landstyle from "../Maps/styles/landspol";
import admstyle from "../Maps/styles/admpol";
import Logger from "../common/Logger";

const keyName = "BaseEditByMapPage";

export default class BaseEditByMapPage extends BaseEditPage {
    static defaultProps = {
        height: '95%',
        width: '95%'
    }
    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        context.tableName = 'meetings';
        context.idName = 'row_id';
        context.columnsCount = [{width: '25'}, {width: '75'}];
        context.fieldsSet =     [
            {title: 'Факт встречи',fieldset: 'meeting',column:0,pos:1},
            {title: 'Описание животного',fieldset:'spec',column:0,pos:2},
            {title:'Карта',fieldset:'map',pos:10,column:1,block:1}
        ];
        context.columnsDefaults =[...context.lastUserColumns,... [
            {column_name:'meeting_num',row:0,pos:0},
            {pos: 0,                 labelAlign: 'left',
                column_name: 'meeting_type', hidden: true},
            {
                pos: 1, row:0,
                column_name: 'meeting_spec',
                labelAlign: 'left',
                fieldset : 'spec',
                is_list: true,
                source: {
                    tableName: 'meetings_spec',
                    titleField: 'spec_name',
                    idField: 'meeting_spec',
                }
            },
            {
                pos: 0,row:1,
                labelAlign: 'left',
                column_name: 'meeting_huntuser',
                is_list: true,
                source: {
                    tableName: 'hunt_users',
                    titleField: 'user_name',
                    idField: 'huntuser_id',
                }
            },
            {
                pos: 0,row:2,
                labelAlign: 'left',
                column_name: 'meeting_oktmo',
                is_list: true,
                source: {
                    tableName: 'regions',
                    titleField: 'region_name',
                    idField: 'oktmo',
                }
            },
            // {column_name:'meeting_date',
            //     labelAlign: 'left',
            //     row:6,pos:6},
            {column_name:'meeting_place',
                labelAlign: 'left',
                pos:7,row:9},
            {column_name:'meeting_comment',
                labelAlign: 'left',
                pos:8,row:20},
            {column_name: 'meeting_count',
                labelAlign: 'left',
                row:1, fieldset: 'spec'},
            {column_name: 'meeting_direction',
                labelAlign: 'left',
                row:4, fieldset: 'spec'},
            {column_name:'geom',pos:11,block:1,fieldset:'map',
                mapButtonNames:['edit','drop'],
                layerNames: [
                    {
                        layerName: 'landspol', hidden: false, type: 'own', styleFunction: landstyle
                    },
                    {
                        layerName: 'admpol', hidden: false, type: 'own', styleFunction: admstyle
                    },
                ]},
        ]];
        context.footerButtonNames = ['saveclose', 'save','delete', 'close'];
    }

    //заголовок формы редактирования по умолчанию
    titleFunc(context, record, parentRow) {
        try {
            context.title = ` ${((record['meeting_date']) ? new Date(record['meeting_date']).toLocaleDateString() : '--.--.-- ')}`;
        } catch (e) {
            context.title = ` --.--.-- `;
        }
        return context.title;
    }

    //есть ли геометрия маршрута
    hasGeom() {
        const context = this;

        // Если olMap не найден напрямую, пытаемся найти его в подкомпонентах
        if (!context.olMap) {

            // Ищем в elements (subTables)
            if (context.elements) {
                for (const key in context.elements) {
                    const element = context.elements[key];
                    // Проверяем разные варианты доступа к olMap
                    if (element?.olMap) {
                        context.olMap = element.olMap;
                        break;
                    }
                    if (element?.props?.olMap) {
                        context.olMap = element.props.olMap;
                        break;
                    }
                    // Проверяем вложенные компоненты через ref
                    if (element?.cmp?.olMap) {
                        context.olMap = element.cmp.olMap;
                        break;
                    }
                }
            }
            
            // Также проверяем в state.subTables или других местах
            if (!context.olMap && context.state?.subTables) {
                // subTables могут содержать ссылки на компоненты
            }
        }
        
        // Теперь ищем feature в разных местах
        let feature = null;
        
        // 1. Ищем в state.features компонента карты (для ZmuPreRouteMap, ZmuRouteMap)
        if (context.olMap?.state?.features && context.olMap.state.features.length > 0) {
            // Ищем feature по типу 'route', 'plan', 'prepare', или из слоя 'pre_routes'
            feature = context.olMap.state.features.find(f => {
                const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                return props.type === 'route' || props.type === 'plan' || props.type === 'prepare' || props.source === 'pre_routes';
            });
            if (feature) {
                return feature;
            }
            // Если не нашли по типу, берем первый
            feature = context.olMap.state.features[0];
            if (feature) {
                return feature;
            }
        }
        
        // 2. Ищем в featuresSource OpenLayers
        if (context.olMap?.featuresSource) {
            const features = context.olMap.featuresSource.getFeatures();

            if (features.length > 0) {
                // Ищем feature по типу или источнику
                feature = features.find(f => {
                    const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                    return props.type === 'route' || props.type === 'plan' || props.type === 'prepare' || props.source === 'pre_routes';
                });
                if (feature) {
                    return feature;
                }
                // Если не нашли по типу, берем первый
                feature = features[0];
                if (feature) {
                    return feature;
                }
            }
        }
        
        // 3. Ищем в gisFeature из подкомпонентов (BaseMapSub)
        if (context.elements) {
            for (const key in context.elements) {
                const element = context.elements[key];
                if (element?.gisFeature) {
                    const gisFeatures = Array.isArray(element.gisFeature) ? element.gisFeature : [element.gisFeature];
                    if (gisFeatures.length > 0) {
                        feature = gisFeatures.find(f => {
                            const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                            return props.type === 'route' || props.type === 'plan' || props.type === 'prepare' || props.source === 'pre_routes';
                        }) || gisFeatures[0];
                        if (feature) {
                            return feature;
                        }
                    }
                }
            }
        }
        
        // 4. Ищем в importantSource (для важных features)
        if (context.olMap?.importantSource) {
            const importantFeatures = context.olMap.importantSource.getFeatures();
            if (importantFeatures.length > 0) {
                feature = importantFeatures.find(f => {
                    const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                    return props.type === 'route' || props.type === 'plan' || props.type === 'prepare' || props.source === 'pre_routes';
                }) || importantFeatures[0];
                if (feature) {
                    return feature;
                }
            }
        }
        
        // 5. Ищем в слоях карты (pre_routesSource и т.д.)
        if (context.olMap) {
            // Проверяем все возможные источники слоев
            const layerSourceNames = ['pre_routesSource', 'preRoutesSource'];
            for (const sourceName of layerSourceNames) {
                if (context.olMap[sourceName]) {
                    const layerFeatures = context.olMap[sourceName].getFeatures();
                    if (layerFeatures.length > 0) {
                        feature = layerFeatures.find(f => {
                            const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                            return props.source === 'pre_routes' || props.type === 'prepare';
                        }) || layerFeatures[0];
                        if (feature) {
                            return feature;
                        }
                    }
                }
            }
        }
        
        return false;
    }

    saveGeometry(params) {
        let {context, feature, path,callback}=params;
        if (!path) path='zmu/routes/gis/';
        if (!feature) feature=context.hasGeom();
        if (!callback) callback=()=>{
            context.olMap.props.parent.getData({context:context.olMap.props.parent});
        };
        if (!feature) return f.toast('Нет данных для сохранения.')
        const geometry = g.toGeoJson(feature);
        if (geometry) {
            let values = new FormData();
            values.append('geometry', JSON.stringify(geometry));
            f.setObjectData({
                context: context,
                id: (context.rowId),
                path,
                values: values,
                callback: callback
            })
        } else
            callback();
    }

}


